import { render, staticRenderFns } from "./CardSelectItem.vue?vue&type=template&id=6b587b0e&scoped=true&"
import script from "./CardSelectItem.vue?vue&type=script&lang=js&"
export * from "./CardSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./CardSelectItem.vue?vue&type=style&index=0&id=6b587b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b587b0e",
  null
  
)

export default component.exports